

  import { Culture } from '../services/Culture';

  import { BusinessCaseService } from '@/services/BusinessCaseService';
  import { container } from "tsyringe";

  import { defineComponent } from 'vue';

  const businessCaseService = container.resolve<BusinessCaseService>(BusinessCaseService);

  export default defineComponent({

    data() {
      return {
        cases: [],
        loaded: false
      }
    },

    methods: {
      formatDateTime: Culture.dateTime,
      
      openDetail(id: number)  {
        this.$router.push('/detail/' + id);
      },

      async fetchBusinessCases() {
        // read cases
        try {
          let cases = await businessCaseService.get();
          this.cases = cases;
        }
        catch(e) {
          this.$router.push('/login');
        }
        this.loaded = true;
      }
    },

    created() {
      this.fetchBusinessCases();
    }

});

